<p-dialog id="editcurrency"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="true"
          [resizable]="true"
          [closable]="!saving"
          [closeOnEscape]="!saving"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '30vw', height: '90hw'}"
  >
  <ng-template pTemplate="content">
    <div class="fluid">
      <div class="field">
        <label for="float-input1">Код Валюты<span *ngIf="!isNewCurrency"> ({{_currencyId}})</span></label>
        <input id="float-input1" type="text" pInputText [(ngModel)]="_currencyCode" [disabled]="saving" [maxLength]="32" placeholder="USD_XXX">
      </div>
      <div class="field">
        <label for="float-input2">Название</label>
        <input id="float-input2" type="text" pInputText [(ngModel)]="_currencyName" [disabled]="saving">
      </div>
      <div class="field">
        <label for="rate-input">Курс Валюты</label>
        <p-inputNumber id="rate-input" [(ngModel)]="_rateValue" (ngModelChange)="markRateTouched()" [disabled]="saving" mode="decimal" [showButtons]="true" [step]="0.05" [minFractionDigits]="2" [maxFractionDigits]="4"></p-inputNumber>
      </div>
      <div class="field">
        <label for="icon">Дата курсу</label>
        <p-calendar [(ngModel)]="_dateValue" (ngModelChange)="markRateTouched()" [disabled]="saving" [showIcon]="true" inputId="icon" dateFormat="dd.mm.yy" firstDayOfWeek="1" appendTo="body"></p-calendar>
      </div>
      <div class="col">
        <p-checkbox [(ngModel)]="_selectAfter" [disabled]="saving" label="Выбрать после закрытия" [binary]="true"></p-checkbox>
      </div>
      <small class="p-error block mt-2" *ngIf="_validationError || saveError">{{ _validationError || saveError }}</small>
    </div>
</ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" (click)="onConfirm('ok')" [disabled]="saving" [loading]="saving"></p-button>
    <p-button label="Отмена" (click)="display=false" [disabled]="saving"></p-button>
  </ng-template>
</p-dialog>
